import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { attachmentExtension } from "../utilities/attachments";

// Stand-in for an <img> preview when an attachment is a document: an <img>
// of a PDF/Excel URL renders as a broken image. Clicking opens the file.
const AttachmentTile = ({ item, url, width = 250, height = 150 }) => {
  const ext = attachmentExtension(item);
  const Icon = ext === "pdf" ? PictureAsPdfIcon : InsertDriveFileIcon;
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => url && window.open(url, "_blank", "noopener,noreferrer")}
      onKeyDown={(e) => {
        if (e.key === "Enter" && url) window.open(url, "_blank", "noopener,noreferrer");
      }}
      style={{
        width,
        height,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        borderRadius: 8,
        border: "1px solid #E2E8F0",
        background: "#F8FAFC",
        cursor: url ? "pointer" : "default",
      }}
    >
      <Icon style={{ fontSize: 48, color: ext === "pdf" ? "#E53935" : "#1273B8" }} />
      <span style={{ fontSize: 12, fontWeight: 700, color: "#475569" }}>
        {(ext || "file").toUpperCase()}
      </span>
    </div>
  );
};

export default AttachmentTile;
